import DOMPurify from "dompurify";

const TARGET_BLANK = "data-keep-target-blank";

// DOMPurify strips target by default; keep target="_blank" on links and force a safe rel
DOMPurify.addHook("beforeSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute(TARGET_BLANK, "1");
  }
});

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.hasAttribute(TARGET_BLANK)) {
    node.removeAttribute(TARGET_BLANK);
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});
